var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 7h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2V5a4 4 0 1 1 8 0v2zm-2 0V5a2 2 0 1 0-4 0v2h4z"}));
}

Lock.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Lock;

Lock.default = Lock;
